import * as React from 'react';

export interface BreakpointContextValues {
    extraLargeUp: boolean;
    largeOnly: boolean;
    largeUp: boolean;
    mediumOnly: boolean;
    mediumUp: boolean;
    smallOnly: boolean;
    smallUp: boolean;
    extraSmallOnly: boolean;
    extraSmallUp: boolean;
}

export const BreakpointContext = React.createContext({
    extraLargeUp: false,
    largeOnly: false,
    largeUp: false,
    mediumOnly: false,
    mediumUp: false,
    smallOnly: false,
    smallUp: false,
    extraSmallOnly: false,
    extraSmallUp: false,
});
